import React, { useContext, useEffect, useState } from "react";
import "./paytmAlert.css";
import Lottie from "lottie-react";
import money from "../../../../assets/lottie/money.json";
import "../../../restaurent-page/components/alert-comp/restaurentAlert.css";
import { off, onValue, ref } from "firebase/database";
import { useNavigate } from "react-router-dom";
import CartContext from "../../../../context/cart_context.js"
import { db } from "../../../../config/firebase_config";


const PaymentAlert = ({
  showPayDialog,
  setShowPayDialog,
  cancelPayment,
}) => {
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem("user"));
  const razorOrderId = localStorage.getItem("razorOrderId");
  const {resetCart } = useContext(CartContext);

  const dabaseRef = ref(
    db,
    `TrackPayments/${userData.phoneNo}/${razorOrderId}`
  );
 

  const paymentListener = () => {
    console.log("initalised ra mawaa..... ." ,`TrackPayments/${userData.phoneNo}/${razorOrderId}`)
    onValue(dabaseRef, (snapshot) => {
      const data = snapshot.val();
      console.log("comming data ....")
      console.log(data);
      console.log("comming data ....")
    //   setPaymentStatus(data);
    console.log( "FROM INIT" , `/orderpage?orderID=${data.dbID}`)
    if(data != null){
      console.log(`/orderpage?orderID=${data.dbID}`)

      if (  data.status == "TXN_SUCCESS") {
        console.log(`orderpage?orderID=${data.dbID}`)
        setShowPayDialog(false);
        setTimeout(() => {
          navigate(`/orderpage?orderID=${data.dbID}`);
        } ,1000 )
        resetCart();
        off(dabaseRef);
      } else if (data.status == "TXN_FAILURE") {
        setShowPayDialog(false);
        cancelPayment();
        off(dabaseRef);
      }
    }
    });
  };

  if(showPayDialog){
    paymentListener();
  }

  return (
    showPayDialog && (
      <div className="alert-box-bg">
        <div className="alert-box-container">
          <h3>Payment Processing</h3>
          <Lottie animationData={money} className="money-lottie" />
          {/* <p>{paymentStatus}</p> */}
          <p>Please wait ...we are processing your UPI transaction . </p>
          <button
            className="cancel-btn "
            onClick={() => {
              setShowPayDialog(false);
              cancelPayment();
              off(dabaseRef);
            }}
          >
            Cancel Payment
          </button>
        </div>
      </div>
    )
  );
};

export default PaymentAlert;
